export class Snapchat {
  private id: string
  private promise?: Promise<any>
  private snaptr?: any
  private email?: string
  private queue: any[]

  constructor(id: string) {
    this.id = id
    this.queue = []
  }

  public pageView(eventName: string, data: any) {
    return new Promise<void>((resolve, reject) => {
      this._load()
        .then(() => {
          this.snaptr('track', 'PAGE_VIEW')
          resolve()
        })
        .catch(err => {
          console.error('Error loading Snapchat')
          reject(err)
        })
    })
  }

  public track(eventName: string, data: any) {
    return new Promise<void>((resolve, reject) => {
      this._load()
        .then(() => {
          this.snaptr('track', eventName, data)
          resolve()
        })
        .catch(err => {
          console.error('Error loading Snapchat')
          reject(err)
        })
    })
  }

  public identify(eventName: string, data: any) {
    return new Promise((resolve, reject) => {
      this._load()
        .then(() => {
          if (data.hasOwnProperty('email')) {
            if (data.email !== '' || data.email !== undefined) {
              this.email = data.email
              this.snaptr('init', this.id, { user_email: this.email })
              resolve(this.email)
            }
          }
          reject('No email')
        })
        .catch(err => {
          console.error('Error loading Snapchat')
          reject(err)
        })
    })
  }

  private _load() {
    return (
      this.promise ||
      (this.promise = new Promise((resolve, reject) => {
        if (this.snaptr) {
          resolve(this.snaptr)
        } else {
          const script = document.createElement('script')

          script.async = true
          script.src = 'https://sc-static.net/scevent.min.js'

          script.onload = () => {
            this.snaptr('init', this.id)
            resolve(this.snaptr)
          }
          script.onerror = error => {
            reject(error)
          }

          const tr: any = (this.snaptr = (window as any).snaptr =
            // tslint:disable-next-line:only-arrow-functions
            function(type: string, name: string, data: any) {
              tr.handleRequest
                ? tr.handleRequest.apply(tr, arguments)
                : tr.queue.push(arguments)
            })
          tr.queue = []
          document.head.appendChild(script)
        }
      }))
    )
  }
}
